import { Action } from '@ngrx/store';


export enum AdmPerfilActionTypes {
  GET_ADM_PERFIL = '[ADM_PERFIL] GetPerfil',
  SET_ADM_PERFIL = '[ADM_PERFIL] SetPerfil',
  EDIT_ADM_PERFIL = '[ADM_PERFIL] EditPerfil',
  DELETE_ADM_PERFIL = '[ADM_PERFIL] DeletePerfil',
  SUCESS_PERFIL = '[ADM_PERFIL] SuccessPerfil',
  FAIL_PERFIL = '[ADM_PERFIL] FailPerfil',
}

export class AdmGetPerfil implements Action {
  readonly type = AdmPerfilActionTypes.GET_ADM_PERFIL;
  constructor() {}
}

export class AdmSetPerfil implements Action {
  readonly type = AdmPerfilActionTypes.SET_ADM_PERFIL;
  constructor(public DatosPerfil: any) {}
}
export class AdmEditPerfil implements Action {
  readonly type = AdmPerfilActionTypes.EDIT_ADM_PERFIL;
  constructor(public DatosPerfil: any) {}
}

export class AdmDeletePerfil implements Action {
  readonly type = AdmPerfilActionTypes.DELETE_ADM_PERFIL;
  constructor(public ObjDel: any) {}
}

export class AdmSuscessPerfil implements Action {
  readonly type = AdmPerfilActionTypes.SUCESS_PERFIL;
  constructor(public Respuesta: any , public TipoR: string) {}
}

export class AdmFailPerfil implements Action {
  readonly type = AdmPerfilActionTypes.FAIL_PERFIL;
  constructor(public Respuesta: any) {}
}


export type AdmPerfilAcciones =
    | AdmGetPerfil
    | AdmSetPerfil
    | AdmEditPerfil
    | AdmDeletePerfil
    | AdmSuscessPerfil
    | AdmFailPerfil;
